module.exports = __webpack_public_path__ + "img/chucha.4411ab23.png";